import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";


// Components
import Navbar from "./Components/Navbar";
import Footer from "./Components/Footer";
import ScrollToTop from "./Components/ScrollToTop";

// Pages
import Home from "./Pages/Home";
import About from "./Pages/About"; 
import Services from "./Pages/Services";
import Contact from "./Pages/Contact";
import LeaderShip from "./Pages/LeaderShip";
import Alliances from "./Pages/Alliances";


function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        {/* Navbar */}
        <Navbar />

        {/* Main Routes */}
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/leadership" element={<LeaderShip/>} />
          <Route path="/alliances" element={<Alliances/>} />
          <Route path="/contact" element={<Contact/>} />
        </Routes>

        {/* Footer */}
        <Footer />
      </div>
    </Router>
  );
}

export default App;
